import { useContext, useEffect } from 'react';
import ResearchSurface from '../components/Research/surface/ResearchSurface';
import { LayoutContext } from '../contexts/LayoutContext';

/**
 * The dedicated research route.
 *
 * Mounted at /research, the canonical path. The strangler path /research2 is
 * kept only as a redirect here so old bookmarks and links still land.
 */
function ResearchPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);

  useEffect(() => {
    // The surface owns its own scrolling regions.
    setIsContentScrollable(false);
    return () => setIsContentScrollable(false);
  }, [setIsContentScrollable]);

  return (
    <div className="h-[calc(100vh-10px)]">
      <ResearchSurface />
    </div>
  );
}

export default ResearchPage;
